import axios from "axios";
import Qs from "qs";
import {createStore} from 'redux';
import {url} from "./env";
// import aes from "./AES";
import MobileDetect from "mobile-detect";
import CryptoJS from 'crypto-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import { Promise } from "es6-promise";

// Promise.polyfill();

// axios.defaults.timeout = 600000;
export const imgPlaceholder = {
  // default: 'data:image/png;base64,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',
  // default: '/resources/index/projectdefault.png',
  default: '/resources/placeholder/game-icon.png',
};

const reducer = (state = {}, action) => {
  if (action.data) {
    return action.data;
  }
  return state;
}

export const redux = createStore(reducer);

const createAxios = axios.create({baseURL: url/*, timeout: 15000*/});
// const createAxios = axios.create({baseURL: url, timeout: 600000});

// createAxios.defaults.timeout = 600000;

const mobileDetect = new MobileDetect(navigator.userAgent);

//浏览器指纹
const fpPromise = FingerprintJS.load();
(async () => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  const visitorId = result.visitorId;

  localStorage.setItem('visitorId', visitorId);
})();

createAxios.interceptors.request.use(
    config => {
      config.paramsSerializer = params => Qs.stringify(params, {arrayFormat: 'indices'})
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['device-type'] = '20';
      config.headers['device-name'] = mobileDetect.phone();
      config.headers['sdk-version'] = '139';
      config.headers['origintype'] = 'react';
      config.headers['react-method'] = window.location.protocol;
      config.headers['react-host'] = window.location.host;
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      if(mobileDetect.os() == 'iOS') {
        config.headers['device-type'] = '10';
        // config.headers['device-version'] = mobileDetect.os() + mobileDetect.versionStr('iPhone').replace(/_/g, ".");
        if(mobileDetect.is('iPad')) {
          config.headers['device-version'] = mobileDetect.os() + mobileDetect.versionStr('iPad')?.replace(/_/g, ".");
        } else if(mobileDetect.is('iPhone')) {
          config.headers['device-version'] = mobileDetect.os() + mobileDetect.versionStr('iPhone')?.replace(/_/g, ".");
        }
      } else if (mobileDetect.os() == 'AndroidOS') {
        config.headers['device-type'] = '20';
        config.headers['device-version'] = mobileDetect.os() + mobileDetect.version('Android');
      }
      // config.headers['channel'] = localStorage.getItem('agent') || 'rr2f';
      config.headers['channel'] = general.agent;
      if (localStorage.getItem('udid')) {
        config.headers['udid'] = localStorage.getItem('udid');
      }
      if (localStorage.getItem('key')) {
        config.headers['fid'] = localStorage.getItem('key');
      }
      let token = localStorage.getItem('token');
      if (token) {
        config.headers['token'] = token;
      }

      let visitorId = localStorage.getItem('visitorId');
      if(visitorId) {
        config.headers['fpid'] = visitorId;
      } else {
        (async () => {
          const fp = await fpPromise;
          const result = await fp.get();

          const visitorId = result.visitorId;
        
          config.headers['fpid'] = visitorId;
          localStorage.setItem('visitorId', visitorId);
        })();
      }
      
      // config.headers['fpid'] = general.visitorId;
      config.headers['tk'] = general.tk?general.tk:'';
      config.headers['tk-url'] = general.tkUrl?general.tkUrl:'';
      config.headers['bd-vid'] = general.bdvid?general.bdvid:'';
      config.headers['exten-d'] = general.extend?general.extend:'';
      config.headers['username'] = localStorage.getItem('username');
      let user_id = localStorage.getItem('user_id');
      let username = localStorage.getItem('username');
      if (user_id || username) {
        if (config.data instanceof FormData) {
          if (!config.data.get('member_id')) {
            config.data.append('member_id', user_id);
          }
          if (!config.data.get('username')) {
            config.data.append('username', username);
          }
        } else {
          config.data = {username, member_id: user_id, ...config.data};
        }
       

      }

      //post数据加密处理
      if (config.method == 'post') {
        // if(config.data) {
        //   //判断需要加密的接口
        //   if(config.url.indexOf('ysyCheckAvailable') == -1 && general.interArr.includes(config.url) == false) {
        //     config.data = {data: encrypt(config.data)};
        //   }
        // }

        //判断需要加密的接口
        if(window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.1.119') {
          if(config.url.indexOf('ysyCheckAvailable') == -1 && config.url.indexOf('getToDayNews') == -1 && general.interArr.includes(config.url) == false) {
            // config.data = {data: encrypt(config.data)};
          }
        }
        
        // console.log(JSON.parse(decrypt('dfeRzNXgpzXu6KA4hUKVrC+tfZq5H3HymzyRj/FaoDhD/OlDF91mOYuyvP3bpbOsSvNfysDKzVnZk0Mjbg4mpuj+kxuLuVj9lYu780IYcmb/lx5yaD7KdfOUWR2uC5QsviCL3v9XGY/PILXGxym8RRoBBMB8TNB/0AImvPxLqCTdTBB0H1XsKW4nHhjmNo8ztmVrKilEfshU2WCNC1tLTg==')));
      }
      
      return config;
    },
    err => {
      return Promise.reject(err);
    }
)

//数据响应拦截器
createAxios.interceptors.response.use(
  req=>{
    //解密解析处理返回值 仅post
    if(req.config.method == 'post') {
      //处理判断需要解密的接口
      if(window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.1.119') {
        if(req.config.url.indexOf('ysyCheckAvailable') == -1 && req.config.url.indexOf('getToDayNews') == -1 && general.interArr.includes(req.config.url) == false) {
          // req['data'] = JSON.parse(decrypt(req.data.data));
        }
      }

      return req;
    }
    
    return req;
  },
  err=>{
    
  }
);

const createAxiosNew = axios.create({baseURL: url/*, timeout: 15000*/});

createAxiosNew.interceptors.request.use(
    config => {
      config.paramsSerializer = params => Qs.stringify(params, {arrayFormat: 'indices'})
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      let user_id = localStorage.getItem('user_id');
      let username = localStorage.getItem('username');
      if (user_id || username) {
        if (config.data instanceof FormData) {
          if (!config.data.get('member_id')) {
            config.data.append('member_id', user_id);
          }
          if (!config.data.get('username')) {
            config.data.append('username', username);
          }
        } else {
          config.data = {username, member_id: user_id, ...config.data};
        }
      }
      
      return config;
    },
    err => {
      return Promise.reject(err);
    }
)

//接口数据加密
const encrypt = (word) => {
  var keyStr = '2%!9vn8(&MK*49)_';
  var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word));
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var datas = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB, 
    padding: CryptoJS.pad.Pkcs7
  });

  // console.log(datas.toString());

  // console.log("hhh");
  // console.log(decrypt('d9EeTVAzH/Otnv7eNpU0tMxtId1Lv/zjTJQG69vcq2MmXta+wDLxdyCdO1/b/yEwzmaHFEZO2+TMjgbbBiKZWYDfAC6fZcwgPxHmwQaICoe9GK7zLQbp9SNUaDVVAJoa0YIU8O1dGLi4Q3k0A6mvbbuDWuin653FhXE/pI2TSYTZFhfkRAXqMpaPBX2gcyp1'));
  return datas.toString();
}

//接口数据解密
const decrypt = (word) => {
  const keyStr = '2%!9vn8(&MK*49)_';
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });

  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

// console.log(window.location.hash.substring(1));
const general = {
  history: null,
  location: null,
  goBack(callback) {
    if (callback) {
      if (general.callback) {
        general.callbacking = true;
        var si = setInterval(() => {
          let url = window.location.hash.substring(1);
          if (url === general.callback || url === '/') {
            clearInterval(si);
            general.callbacking = null;
            general.callback = null;
            redux.dispatch({
              type: 'type',
              data: {
                url: url,
              }
            });
          } else {
            window.history.back();
          }
        }, 250);
      }
    }
  },
  axios: createAxios,
  axiosnew: createAxiosNew,
  isLogin() {
    return !!localStorage.getItem('token');
  },
  agent: localStorage.getItem('agent') || 'rr2f',
  setAgent() {
    localStorage.setItem('agent', this.agent);
  },
  udid: localStorage.getItem('udid'),
  setUdid() {
    localStorage.setItem('udid', this.udid);
  },
  key: localStorage.getItem('key'),
  setKey() {
    localStorage.setItem('key', this.key);
  },
  app: JSON.parse(localStorage.getItem('app')) || {
    appname: '咪噜游戏',
    appicon: '/resources/icon.png',
    applogo: '/resources/account/logo.png',
  },
  setApp() {
    localStorage.setItem('app', JSON.stringify(this.app));
  },
  visitorId: localStorage.getItem('visitorId'),
  setVisitorId() {
    localStorage.setItem('visitorId', this.visitorId);
  },
  mb: localStorage.getItem('mb'),
  setMb() {
    localStorage.setItem('mb', this.mb);
  },
  config: {},
  user: {},
  rebateContent: '',
  activeInfo: {},
  copyright: '',
  searchHistory: {},
  questions: {},
  tk: '',
  tkUrl: '',
  bdvid: '',
  extend: '',
  navLists: [],
  copyPopState: '',
  indexNumberState: 0,
  randomColorInfo: ['#a7d676', '#ffa95c', '#ffc000', '#79b8ff', '#54C5CD'],
  ceshiNumbei: ['ceshi1', 'ceshi2', 'ceshi3', 'ceshi4', 'ceshi5', 'ceshi6', 'ceshi7', 'ceshi8', 'ceshi9', 'maiyouceshi'],
  interArr: ['/base/comment/add', '/base/feedback', '/user/trade/submitTradeDetail', '/user/trade/uploadImagePublicOss', '/user/user/uploadAvatar', '/upload_image', '/base/tool/adddata','/base/community/image','/base/community/video','/cloudMachineFeedBack'],//不需要加密接口数组
  whether: localStorage.getItem('whether') || 'true',
  setWhether() {
    localStorage.setItem('whether', this.whether);
  }
  // placeholderAgent: ['ue70', 'w8v6', 'rr2f']，
}

export default general;